// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"J8-z"};